export default {
  namespaced: true,
  state: () => ({
    uploadedLogos: {},
  }),

  mutations: {
    /**
     * Salva/atualiza o logo enviado para um design específico.
     * Se `extraFee` não for informado, ele é derivado de:
     *   - `isInvalidSvg === true`  OU
     *   - `isSvgFile === false`
     *
     * @param {Object} state
     * @param {{
     *  key: string|number,
     *  logoKey?: string|null,
     *  logoColor?: { id:number, name?:string, hexCode?:string }|null,
     *  isInvalidSvg?: boolean,
     *  isSvgFile?: boolean,
     *  logoUrl?: string|null,
     *  extraFee?: boolean
     * }} payload
     */
    SET_UPLOADED_LOGO(
      state,
      {
        key,
        logoKey = null,
        logoColor = null,
        isInvalidSvg,
        isSvgFile,
        logoUrl = null,
        extraFee,
      }
    ) {
      const derivedExtraFee =
        typeof extraFee === "boolean"
          ? extraFee
          : isInvalidSvg === true || isSvgFile === false;

      state.uploadedLogos[key] = {
        ...(state.uploadedLogos[key] || {}),
        logoKey,
        logoUrl,
        logoColor,
        ...(typeof isInvalidSvg === "boolean"
          ? { isInvalidSvg: !!isInvalidSvg }
          : {}),
        extraFee: !!derivedExtraFee,
      };
    },

    CLEAR_UPLOADED_LOGO(state, key) {
      delete state.uploadedLogos[key];
    },

    RESET_LOGOS(state) {
      state.uploadedLogos = {};
    },
  },

  actions: {
    setUploadedLogo({ commit }, payload) {
      commit("SET_UPLOADED_LOGO", payload);
    },
    clearUploadedLogo({ commit }, key) {
      commit("CLEAR_UPLOADED_LOGO", key);
    },
    resetLogos({ commit }) {
      commit("RESET_LOGOS");
    },
  },

  getters: {
    getLogo:
      (state) =>
      ({ designId }) =>
        (designId && state.uploadedLogos[designId]) || null,
  },
};
